import React from 'react';
import { Alert, Button, Spinner } from 'react-bootstrap';
import { useAuth } from '../contexts/AuthContext';

const LoginButton = ({ variant = "primary", size = "md", className = "", text = "Sign in with Microsoft" }) => {
    const { login, loggingIn, loginError } = useAuth();

    // Always show login button when SSO is enabled

    return (
        <>
            <Button
                variant={variant}
                size={size}
                className={className}
                onClick={login}
                disabled={loggingIn}
            >
                {loggingIn ? (
                    <>
                        <Spinner
                            as="span"
                            animation="border"
                            size="sm"
                            role="status"
                            aria-hidden="true"
                            className="me-2"
                        />
                        Signing in...
                    </>
                ) : (
                    <>
                        <i className="fas fa-sign-in-alt me-2"></i>
                        {text}
                    </>
                )}
            </Button>

            {loginError && (
                <Alert variant="danger" className="mt-3 mb-0 text-start" role="alert">
                    <i className="fas fa-exclamation-triangle me-2"></i>
                    {loginError}
                </Alert>
            )}
        </>
    );
};

export default LoginButton;
